import React, {useEffect, useRef} from "react";
import {connect} from "react-redux";
import SqftFeaturesPopup from "./sqftFeaturesPopup";
import eventManager from "../../sqft/components/canvas/store/sqftEventManager";
import {changeSqftFeaturesPopup} from "../../../actions/sqftFunctions";
import {handleOpenConflictPopups} from "../../../misc/conflictPopups";

const SqftFeaturesPopupWrapper = (props) => {
  const { sqftFeaturesPopup, changeSqftFeaturesPopup } = props;
  const isOpened = sqftFeaturesPopup.opened;
  const wrapperRef = useRef(null);

  useEffect(() => {
    const closePopup = () => {
      changeSqftFeaturesPopup({ opened: false, sqftPassedData: null });
      handleOpenConflictPopups();
    };

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        closePopup();
      }
    };
    const sender = "popupWrapper";
    if (isOpened) {
      document.addEventListener("mousedown", handleClickOutside);
      eventManager.addEvent(
        eventManager.events.MOUSE_DOWN,
        closePopup,
        sender,
        eventManager.priorities.OVERALL
      );
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      eventManager.removeEvent(sender, eventManager.events.MOUSE_DOWN);
    };
  }, [wrapperRef, isOpened, changeSqftFeaturesPopup]);

  return (
    <div className={"ui-popup sqft-popup sqft-popupv2 " + (isOpened ? "sqft-popupv2--opened" : "")}
         ref={wrapperRef}>
      <SqftFeaturesPopup/>
    </div>
  );
};

const mapStateToProps = (store) => {
  const {sqftFeaturesPopup, sqftFromFeature} = store.sqftState;
  return {
    sqftFeaturesPopup,
    sqftFromFeature,
  };
};

const mapDispatchToProps = {
  changeSqftFeaturesPopup
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupWrapper);
